import { ApiClient } from 'src/api/axiosClient'
import {
  IApplicant,
  IApplicantResponse,
  IApplicationQuery,
} from 'src/interfaces/application-management'

export const applicationManagementAPI = {
  getApplicationList: async ({
    page,
    limit,
    search,
    startDate,
    endDate,
  }: IApplicationQuery) => {
    return await ApiClient.get<IApplicantResponse>(`job-applications`, {
      params: { page, limit, search, startDate, endDate },
    })
  },
  getDetailApplicationId: async (id: string) => {
    return await ApiClient.get<IApplicant>(`job-applications/${id}`)
  },
  deleteApplicationPost: async (id: string) => {
    return await ApiClient.delete(`job-applications/${id}`)
  },
}
